// extracted by mini-css-extract-plugin
export default {"select-content":"mDGjpk8TX9Agt0ZCongH1w=="};